import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { ProAdMsgCollapse } from '@chat/components';
import { GM_AVATAR, GM_NICK, IM_AVATAR, IM_NICK } from '@/helpers/userInfo';
import {
    IM_CUSTOM_MESSAGE,
    IM_MESSAGE,
    IM_MESSAGE_FILE,
    IM_MESSAGE_FORM,
    IM_MESSAGE_VIDEO
} from '@/typings/global';
import MsgCollect from './MsgCollect';
import MsgVideo from './MsgVideo';
import MsgCustom from './MsgCustom';
import MsgActions from './MsgActions';

function Msg(props: IM_MESSAGE): JSX.Element {
    const { type, message, avatar, nick, msg_type, id } = props;
    const { support_msg_collapse } = IM.SDKServer.getState();
    const { sess_id, video_temp_list } = useSelector(
        ({ IMReducer }) => ({
            sess_id: IMReducer.sess_id,
            video_temp_list: IMReducer.video_temp_list
        }),
        shallowEqual
    );
    if (
        msg_type === 'video' &&
        video_temp_list.find((item) => item === (message as IM_MESSAGE_VIDEO).uuid)?.length >= 1
    ) {
        return null;
    }
    const defaultMessage = (
        <div
            className="im-message-content"
            onClick={IM.SDKServer.DomClick}
            dangerouslySetInnerHTML={{ __html: message as string }}
        />
    );
    const MsgSwiper = {
        file: (
            <div className="im-message-content im-message-file">
                <a
                    href={`/chat${(message as IM_MESSAGE_FILE).file_url}`}
                    target="__blank"
                    onClick={(e) =>
                        IM.SDKServer.downloadFile(
                            'dom',
                            e,
                            `${window.location.origin}/chat${
                                (message as IM_MESSAGE_FILE).file_url
                            }`,
                            (message as IM_MESSAGE_FILE).full_url,
                            (message as IM_MESSAGE_FILE).file_name,
                            (message as IM_MESSAGE_FILE).file_ext
                        )
                    }
                >
                    <i className="ic-file" />
                    <div className="content">
                        <p className="title">{(message as IM_MESSAGE_FILE).file_name}</p>
                        <p className="size">{(message as IM_MESSAGE_FILE).file_size}</p>
                    </div>
                </a>
            </div>
        ),
        collect_create: <MsgCollect message={message} msg_type="collect_create" />,
        collect_reject: <MsgCollect message={message} msg_type="collect_reject" />,
        collect_edit: <MsgCollect message={message} msg_type="collect_edit" />,
        form: (
            <div className="im-message-content im-message-form">
                <div className="txt">请点击下方入口填写表单</div>
                <div
                    className="link"
                    onClick={() =>
                        IM.SDKServer.openFormView({
                            type: (message as IM_MESSAGE_FORM).form_type,
                            token: (message as IM_MESSAGE_FORM).token,
                            sess_id
                        })
                    }
                >
                    <img src={(message as IM_MESSAGE_FORM).icon?.full_uri} alt="" />
                    {(message as IM_MESSAGE_FORM).f_form_type}
                </div>
            </div>
        ),
        _video: <MsgVideo message={message as IM_MESSAGE_VIDEO} />,
        video: <MsgVideo message={message as File} />,
        audit: (
            <div className="im-message-content im-message-audit-tip">
                <i className="audit-tip__icon" />
                <span className="audit-tip__txt">消息包含不适宜内容，已自动屏蔽</span>
            </div>
        ),
        ssbq_custom_card_msg: <MsgCustom message={message as IM_CUSTOM_MESSAGE} />,
        default: defaultMessage
    };
    return (
        <li className={`im-message-${type}`}>
            {type === 'in' && GM_AVATAR(avatar, nick)}
            {type === 'out' &&
                IM_AVATAR(
                    msg_type === '_video' ? 'video' : avatar,
                    msg_type === '_video' ? 'video' : nick
                )}
            <div className="im-message-block">
                {type === 'in' && GM_NICK(avatar, nick)}
                {type === 'out' &&
                    IM_NICK(
                        msg_type === '_video' ? 'video' : avatar,
                        msg_type === '_video' ? 'video' : nick
                    )}
                {support_msg_collapse && (
                    <ProAdMsgCollapse enabled recomputeKey={`${id}-${msg_type}`}>
                        {MsgSwiper[msg_type] || MsgSwiper.default}
                    </ProAdMsgCollapse>
                )}
                {!support_msg_collapse && (MsgSwiper[msg_type] || MsgSwiper.default)}
                <MsgActions item={props} />
            </div>
        </li>
    );
}

export default Msg;
